
export const dropdown = [
  "2022", "2025"
]

export const decielen = {
  D1: {
    "2020": 0.017,
    "2021": 0.019,
    "2022": 0.022,
    "2023": 0.027,
    "2024": 0.032,
    "2025": 0.037,
    "2026": 0.055,
    "2027": 0.072,
    "2028": 0.094,
    "2029": 0.124,
    "2030": 0.156
  },
  D2: {
    "2020": 0.018,
    "2021": 0.021,
    "2022": 0.026,
    "2023": 0.032,
    "2024": 0.041,
    "2025": 0.050,
    "2026": 0.070,
    "2027": 0.085,
    "2028": 0.113,
    "2029": 0.140,
    "2030": 0.182
  },
  D3: {
    "2020": 0.024,
    "2021": 0.034,
    "2022": 0.041,
    "2023": 0.054,
    "2024": 0.065,
    "2025": 0.089,
    "2026": 0.110,
    "2027": 0.133,
    "2028": 0.161,
    "2029": 0.207,
    "2030": 0.257
  },
  D4: {
    "2020": 0.026,
    "2021": 0.037,
    "2022": 0.045,
    "2023": 0.060,
    "2024": 0.073,
    "2025": 0.098,
    "2026": 0.115,
    "2027": 0.145,
    "2028": 0.180,
    "2029": 0.220,
    "2030": 0.274
  },
  D5: {
    "2020": 0.035,
    "2021": 0.051,
    "2022": 0.065,
    "2023": 0.080,
    "2024": 0.094,
    "2025": 0.115,
    "2026": 0.145,
    "2027": 0.180,
    "2028": 0.224,
    "2029": 0.285,
    "2030": 0.331
  }
}

